export const getVideoThumbnailAlt = (
  nickName: string,
  videoTitle: string | null,
  coordinateItems: {
    brandName?: string
    categoryName?: string
    childCategoryName?: string
  } = {}
) => {
  const videoTitleText = videoTitle ? `-${videoTitle}` : ''
  const { brandName, categoryName, childCategoryName } = coordinateItems
  if (!brandName && !categoryName && !childCategoryName) {
    return `${nickName}さんのノウハウ動画${videoTitleText}`
  }
  const brandText = brandName ? `${brandName}の` : ''
  const categoryText = childCategoryName || categoryName || 'アイテム'
  return `${brandText}${categoryText}を使った${nickName}さんのノウハウ動画${videoTitleText}`
}
